const icon = require('vue-svgicon');
icon.register({
    'plus-round': {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: `<rect pid="0" y="1" width="23" height="23" rx="11.5" _fill="#DFDFDF"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M12 7h-1v5H6v1h5v5h1v-5h5v-1h-5V7z" _fill="#000"/>`,
    },
});
